// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fK5e","content":"styles_content__18vqO","row":"styles_row__3Og1G","footer":"styles_footer__3TM-u","phraseLength":"styles_phraseLength__2GUXf"};